#import "../fragments/calendar-fragment.graphql"

query GetCalendars($username: String) {
    calendars(username: $username) {
        ...CalendarFragment
    }
}
